/* eslint-disable */
import { grpc } from '@improbable-eng/grpc-web';
import * as pbm from 'js_pb';
import * as pbs from 'js_pb_service';
import config from '../../config.js';

const host = 'https://' + config.domain + ':443';

export const M = (messageName, obj) => {
  const m = new pbm[messageName]();
  Object.keys(obj).forEach(k => {
    const k1 = k.charAt(0).toUpperCase() + k.slice(1);
    if (m[`set${k1}`]) {
      m[`set${k1}`](obj[k]);
    }
  });
  return m;
};

export const unary = (servicemethod, message) =>
  new Promise((resolve, reject) => {
    try {
      const sm = servicemethod.split('.');
      grpc.unary(pbs[sm[0]][sm[1]], {
        request: message,
        host,
        onEnd: res => {
          if (res.status !== 0) {
            if (res.statusMessage !== '') {
              reject(new Error(res.statusMessage));
              return;
            }
            reject(new Error(`Server Error Code: ${res.status}`));
            return;
          }
          resolve(res.message.toObject());
        }
      });
    } catch (e) {
      reject(new Error(e.message));
    }
  });

export const invoke = (servicemethod, message, onMessage, onClose) => {
  try {
    const sm = servicemethod.split('.');
    return grpc.invoke(pbs[sm[0]][sm[1]], {
      request: message,
      host,
      onMessage: res => {
        onMessage(res.toObject());
      },
      onEnd: res => {
        if (res.status !== 0) {
          if (res.statusMessage !== '') {
            onClose(new Error(res.statusMessage));
            return;
          }
          onClose(new Error(`Server Error Code: ${res.status}`));
          return;
        }
        onClose(new Error(''));
      }
    });
  } catch (e) {
    onClose(new Error(e.message));
  }
};
